/**
 * Cloudinary Configuration
 * 
 * Configuration for Cloudinary image storage service.
 * Used instead of Firebase Storage for cost savings.
 * 
 * Free tier: 25GB storage, 25GB bandwidth/month
 * 
 * Setup:
 * 1. Create account at https://cloudinary.com/
 * 2. Get your cloud name from the dashboard
 * 3. Create an unsigned upload preset in Settings > Upload
 * 4. Add environment variables to .env file
 */

const cloudinaryConfig = {
  cloudName: import.meta.env.VITE_CLOUDINARY_CLOUD_NAME,
  uploadPreset: import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET,
}

// Validate required configuration
export function validateCloudinaryConfig() {
  const missing = []
  if (!cloudinaryConfig.cloudName) {
    missing.push('VITE_CLOUDINARY_CLOUD_NAME')
  }
  if (!cloudinaryConfig.uploadPreset) {
    missing.push('VITE_CLOUDINARY_UPLOAD_PRESET')
  }
  
  return {
    isValid: missing.length === 0,
    missing,
  }
}

// Log warning if not configured (only in development)
if (import.meta.env.DEV) {
  const validation = validateCloudinaryConfig()
  if (!validation.isValid) {
    console.warn(
      'Cloudinary configuration missing. Please set these environment variables:',
      validation.missing.join(', ')
    )
  }
}

export default cloudinaryConfig





